import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SidebarMenuCollapsible } from 'app/domains/common-ui';
import { useDesktopNavigation } from '../../../DesktopNavigation';
import { CollapsibleItemLink } from '../CollapsibleItemLink';
import { useLinkMatch } from '../useLinkMatch';
export function CollapsibleDocuments() {
    const { collapsibleStates, toggleCollapsible } = useDesktopNavigation();
    const activeChild = useLinkMatch({
        matchPath: ['/files', '/drafts', '/all-documents', '/document/:id'],
        matchExact: false,
    });
    return (<SidebarMenuCollapsible icon={<Falcon icon="files"/>} label={t({ comment: 'Sidebar menu - Repository label', message: 'Repository', context: 'sidebar' })} activeChild={activeChild} collapsibleKey="repository" open={collapsibleStates.repository} onToggle={toggleCollapsible}>
      <CollapsibleItemLink to="/files" label={t({ comment: 'Sidebar menu - Files label', message: 'Folders', context: 'sidebar' })} matchPath={['/files/:folderId?', '/document/:id']}/>
      <CollapsibleItemLink to="/all-documents" label={t({ comment: 'Sidebar menu - All documents label', message: 'All documents', context: 'sidebar' })} matchPath={['/all-documents']}/>
      <CollapsibleItemLink to="/drafts" label={t({ comment: 'Sidebar menu - Template drafts label', message: 'Template drafts', context: 'sidebar' })} matchPath={['/drafts']}/>
    </SidebarMenuCollapsible>);
}
